/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of governance proposals */
export enum ProposalType {
  ParameterUpdate,
  ProtocolUpgrade,
  TreasuryOperation,
  FeeUpdate,
  SecurityUpdate,
  GovernanceUpdate,
  EmergencyAction,
  Custom,
}

export type ProposalTypeArgs = ProposalType;

export function getProposalTypeEncoder(): FixedSizeEncoder<ProposalTypeArgs> {
  return getEnumEncoder(ProposalType);
}

export function getProposalTypeDecoder(): FixedSizeDecoder<ProposalType> {
  return getEnumDecoder(ProposalType);
}

export function getProposalTypeCodec(): FixedSizeCodec<
  ProposalTypeArgs,
  ProposalType
> {
  return combineCodec(getProposalTypeEncoder(), getProposalTypeDecoder());
}
